import React from 'react';
import { useSelector } from 'react-redux';
import { bool } from 'prop-types';
import classnames from 'classnames';
import * as styles from './ProductsLoader.css';

const ProductsLoader = ({ hasProducts }) => {
    const {
        deviceType: { isDesktop = true, isMobile = false, isTablet = false } = {},
        featureFlags: {
            enableDesktopViewForTabletLandscapeOrientation: enableDesktopViewForTablet = false,
            enableThreeColumnGrid = true,
        } = {},
        sliderStatus = false,
    } = useSelector(({ context }) => context);

    const isTabletView = isTablet && enableDesktopViewForTablet && !sliderStatus;
    const isDesktopView = isDesktop || isTabletView;
    const isMobileView = isMobile || !isDesktopView;

    const skeletons = [];

    let productCount = enableThreeColumnGrid ? 3 : 4;
    if (isMobile) productCount = 2;

    const Skeleton = () => (
        <div
            className={classnames(
                'bg-gray-100',
                'border-1',
                'border-solid',
                'border-gray-100',
                'mb-4',
                'ml-1',
                'overflow-hidden',
                'relative',
                styles.loading,
                {
                    [styles.mobile]: isMobileView,
                    [styles.tablet]: isTabletView,
                    'inline-block': !hasProducts,
                    'w-1/2': !hasProducts && isMobileView,
                    'w-1/3': !hasProducts && !isMobileView && enableThreeColumnGrid,
                    'w-1/4': !hasProducts && !isMobileView && !enableThreeColumnGrid,
                    'w-full': hasProducts,
                }
            )}
        />
    );

    for (let index = 0; index < productCount; index += 1) {
        skeletons.push(<Skeleton key={index} />);
    }

    return hasProducts ? (
        <Skeleton />
    ) : (
        <div className={classnames('flex', 'w-full')}>{skeletons}</div>
    );
};

ProductsLoader.defaultProps = {
    hasProducts: false,
};

ProductsLoader.propTypes = {
    hasProducts: bool,
};

export default ProductsLoader;
